// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__mWZSF","alert":"SettungsInbox_alert__2nxqu"};